module.exports = __webpack_public_path__ + "static/media/scoliosis_normal.ee38bf9f.png";